// Demo-Mode-Schalter für die öffentliche Live-Demo.
//
// Aktiv, wenn entweder zur Build-Zeit `VITE_DEMO_MODE=true` gesetzt ist
// (statisches Demo-Deployment) oder die Seite unter `demo.truucost.com`
// (bzw. einem `demo.`-Host) ausgeliefert wird. Im Demo-Mode liest die App
// anonymisierte JSON-Fixtures statt das echte Backend anzusprechen und es
// gibt keinen Login. Siehe docs/marketing_demo_sync.md.

let cached: boolean | null = null;

export function isLegacyAuthMode(): boolean {
  return import.meta.env.VITE_SUPABASE_DISABLED === "true";
}

export function isDemoMode(): boolean {
  if (cached !== null) return cached;
  let value = false;
  if (import.meta.env.VITE_DEMO_MODE === "true") {
    value = true;
  } else if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "demo.truucost.com" || host.startsWith("demo.")) {
      value = true;
    }
  }
  cached = value;
  return value;
}

// Synthetischer Nutzer für den Demo-Mode (kein echter Account, kein Login).
export const DEMO_USER = {
  user_id: "demo-user",
  email: "demo@truucost.com",
  customer_id: "demo",
  active_membership: {
    tenant_slug: "demo",
    tenant_name: "TruuCost Demo",
    role: "member",
    can_manage_members: false,
    can_manage_sources: false,
    can_manage_data_quality: false,
    can_use_legacy_identity_review: false,
    // Die Demo zeigt den Controlling-Umfang, aber keine Importe (#538).
    can_review_prices: true,
    can_manage_cost_centers: true,
    can_manage_imports: false,
    can_manage_purchase_selections: true,
    can_upload_documents: true,
    can_approve_order_confirmations: true,
    fiscal_year_start_month: 3,
  },
  memberships: [
    {
      tenant_slug: "demo",
      tenant_name: "TruuCost Demo",
      role: "member",
      is_active: true,
    },
  ],
} as const;

// Ziel des „Zur Website"-Links im Demo-Banner.
export const DEMO_MARKETING_URL = "https://truucost.com";
